import { render } from "./TournamentPlayerData.vue?vue&type=template&id=c577cc30&ts=true"
import script from "./TournamentPlayerData.vue?vue&type=script&lang=ts"
export * from "./TournamentPlayerData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Reports/TournamentPlayerData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c577cc30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c577cc30', __exports__)) {
    api.reload('c577cc30', __exports__)
  }
  
  module.hot.accept("./TournamentPlayerData.vue?vue&type=template&id=c577cc30&ts=true", () => {
    api.rerender('c577cc30', render)
  })

}


export default __exports__